export const instructionsByTransferPartner = {
  "Medicare Customer Care":
    "Only transfer Medicare customers here that have already enrolled into a plan. Hours of customer care are M-F, 8am EST to 6pm EST. Outside of these hours, please transfer over to a Medicare Agent.",
  "Health Customer Care":
    "Only transfer Health (u65) customers here that have already enrolled into a plan. Hours of customer care are M-F, 8am EST to 6pm EST. Outside of these hours, please have customer call back at 855-615-0992 during office hours.",
};
